const ns = "@@chat";

export const Actions = {
  FETCH_UNREAD_COUNT: `${ns}/FETCH_UNREAD_COUNT`,
  SET_UNREAD: `${ns}/SET_UNREAD`,
  CONVERSATION_UPDATED: `${ns}/CONVERSATION_UPDATED`,
  READ_UPDATED: `${ns}/READ_UPDATED`,
};

export const fetchUnreadCount = () => ({
  type: Actions.FETCH_UNREAD_COUNT,
});

// Read positions of every conversation, from GET /chat/unread-count
export const setUnread = (conversations) => ({
  type: Actions.SET_UNREAD,
  conversations,
});

export const conversationUpdated = (conversationId, lastMessage, currentStaffId) => ({
  type: Actions.CONVERSATION_UPDATED,
  conversationId,
  lastMessage,
  currentStaffId,
});

export const readUpdated = (conversationId, lastReadSeq) => ({
  type: Actions.READ_UPDATED,
  conversationId,
  lastReadSeq,
});
